import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logos/logo.svg';
import mobileLogo from '../../assets/logos/favicon-1.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleSectionClick = (sectionId) => {
    if (location.pathname === '/') {
      // If already on home page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on different page, navigate to home then scroll to section
      navigate('/');
      // Use setTimeout to ensure the page has loaded before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
              <img 
                src={isMobile ? mobileLogo : logo} 
                alt="Aqua Broadcast" 
                className="logo-image" 
              />
            </div>
            
            {/* Desktop Navigation */}
            <nav className="nav desktop-nav">
              <Link to="/">الرئيسية</Link>
              <a href="#about" onClick={(e) => { e.preventDefault(); handleSectionClick('about'); }}>من نحن</a>
              <Link to="/products">المنتجات</Link>
              <Link to="/technology">التكنولوجيا</Link>
              <a href="#support" onClick={(e) => { e.preventDefault(); handleSectionClick('support'); }}>الدعم</a>
              <Link to="/contact">اتصل بنا</Link>
            </nav>

            {/* Mobile Menu Button */}
            <button className="mobile-menu-button" onClick={toggleMobileMenu}>
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-overlay" onClick={closeMobileMenu}></div>
        <nav className="sidebar-nav">
          <div className="sidebar-header">
            <img src={mobileLogo} alt="Aqua Broadcast" className="sidebar-logo" />
            <button className="close-button" onClick={closeMobileMenu}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div className="sidebar-links">
            <Link to="/" onClick={closeMobileMenu}>الرئيسية</Link>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleSectionClick('about'); closeMobileMenu(); }}>من نحن</a>
            <Link to="/products" onClick={closeMobileMenu}>المنتجات</Link>
            <Link to="/technology" onClick={closeMobileMenu}>التكنولوجيا</Link>
            <a href="#support" onClick={(e) => { e.preventDefault(); handleSectionClick('support'); closeMobileMenu(); }}>الدعم</a>
            <Link to="/contact" onClick={closeMobileMenu}>اتصل بنا</Link>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
